import { fetchWrapper } from "@/helpers/fetch-wrapper";

const API_URL = process.env.VUE_APP_SERVER_URL;

export async function getNotificationsFromServer(page = 1, limit = 5) {
    try {
        const response = await fetchWrapper.get(`${API_URL}/api/my-notifications?page=${page}&limit=${limit}`);
        return response.data;
    } catch (error) {
        console.error('Lỗi khi lấy thông báo:', error);
        return { data: [], total: 0, page: 1, totalPages: 1 };
    }
}


export async function toggleNotificationFromServer(value) {
    try {
        const response = await fetchWrapper.post(`${API_URL}/api/toggle-notification`, {
            notification_enabled: value
        });
        return response.data;
    } catch (error) {
        console.error('Lỗi khi bật/tắt thông báo:', error);
        throw error;
    }
}

export async function markAllNotificationsAsReadFromServer() {
    try {
        const response = await fetchWrapper.put(`${API_URL}/api/my-notifications/mark-all-as-read`);
        return response.data;
    } catch (error) {
        console.error('Lỗi khi đánh dấu tất cả thông báo đã đọc:', error);
        throw error;
    }
}


export async function markNotificationAsReadFromServer(notificationId) {
    try {
        const response = await fetchWrapper.put(`${API_URL}/api/my-notifications/${notificationId}/mark-as-read`);
        return response.data;
    } catch (error) {
        console.error('Lỗi khi đánh dấu thông báo đã đọc:', error);
        throw error;
    }
}


export async function countUnread() {
    try {
        const response = await fetchWrapper.get(`${API_URL}/api/my-notifications/count-unread`);
        return response.data;
    } catch (error) {
        console.error('Lỗi khi đếm thông báo chưa đọc:', error);
        throw error;
    }
}
    
    